import { ValuesCarousel } from "./values-carousel";
import type { SectionData } from "@/lib/types/cms-types";

export interface CultureSectionProps {
  cmsData: {
    culture?: SectionData;
  };
}

export default function CultureSection({ cmsData }: CultureSectionProps) {
  const content = cmsData.culture?.content;

  // Define default bullet points
  const defaultBulletPoints = [
    {
      title: "Work-life balance",
      description:
        "Enjoy flexible schedules and comprehensive wellness programs designed to support your overall well-being.",
    },
    {
      title: "Collaboration",
      description:
        "Experience our open office environment and participate in regular team-building activities that foster creativity and innovation.",
    },
    {
      title: "Growth",
      description:
        "Benefit from our mentorship programs and continuous learning opportunities to accelerate your career development.",
    },
  ];

  const bulletPoints = content?.bulletPoints?.length
    ? content.bulletPoints
    : defaultBulletPoints;

  return (
    <section
      data-scroll-section
      className="min-h-screen w-full max-w-full overflow-x-hidden box-border py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8 flex items-center"
      id="culture"
      style={{ backgroundColor: "#f7f9fc" }}
    >
      <div className="max-w-7xl mx-auto w-full min-w-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 min-w-0">
          {/* Work Culture Section (Left Side) */}
          <div className="min-w-0 bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-md">
            <h2
              className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6"
              style={{
                color: "#164a7a",
              }}
            >
              {content?.title || "Work-Life Harmony in Action"}
            </h2>
            <p className="text-gray-700 mb-4 sm:mb-6 text-sm sm:text-base">
              {content?.description ||
                "At DANA, we believe in creating an environment where our team can thrive both professionally and personally."}
            </p>
            <ul className="space-y-3 mb-6 sm:mb-8">
              {bulletPoints.map((point, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-[#328ee9] mr-2 flex-shrink-0">✓</span>
                  <span className="text-sm sm:text-base break-words min-w-0">
                    <strong className="text-[#328ee9]">{point.title}:</strong>{" "}
                    {point.description}
                  </span>
                </li>
              ))}
            </ul>
            <div className="relative h-48 sm:h-64 rounded-lg overflow-hidden">
              <img
                src="/banner-3.webp"
                alt="DANA team collaboration"
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              />
            </div>
          </div>

          {/* Values Section (Right Side) */}
          <div className="min-w-0 bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-md">
            <ValuesCarousel cmsData={cmsData} />
          </div>
        </div>
      </div>
    </section>
  );
}
